import { TituloAbaService } from './../titulo-aba/titulo-aba.service';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
// import data from '../../post.json'
import { Observable } from 'rxjs';
@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrl: './blog.component.scss'
})
export class BlogComponent implements OnInit {

  mainHeader: any;
  featuredPost: any;
  showModal: boolean = false;
  destaquePosts: any;
  bannerPosts: any;
  searchTerm: string = '';
  searchActive: boolean = false;
  viewAllPosts: boolean = false
  filteredPost: any = []
  posts: any[] = [];
  public env = environment
  public apiUrl = `${this.env.origin}/blogmidias/post.json`;

  categories: string[] = [
    'Todos',
    'Gestão de negócios',
    'Meios de pagamento',
    'Tendências de Mercado',
    'Gestão financeira'
  ];

  selectedCategory: string = ''; // Categoria selecionada

  constructor(private http: HttpClient, private tituloAbaService: TituloAbaService) {
    this.tituloAbaService.setTitle('Blog da azulzinha ')
    this.tituloAbaService.setMeta('description', 'Fique por dentro das dicas, tutoriais, tendências de mercado e novidades da azulzinha, a maquininha de cartões da CAIXA. Acesse agora e saiba mais.');
  }

  async ngOnInit(): Promise<void> {
    window.scrollTo(0, 0);
    await this.getData();
    // this.posts = data
    this.handleFilterPost();

  }
  async getData() {
    try {
      const response = await this.http.get(this.apiUrl).toPromise();
      this.posts = response as any[];  // Assegura que response seja tratado como um array
    } catch (error) {
      console.log('Erro ao buscar dados', error);
    }
  }

  handleFilterPost(): void {
    this.destaquePosts = this.posts.filter(post => post.type === 'destaque');
    this.bannerPosts = this.posts.filter(post => post.type === 'banner');

  }
  showAllPosts() {
    setTimeout(() => {
      window.scrollTo(0, 0)
      document.documentElement.scrollTop = 0; // Para navegadores modernos
      document.body.scrollTop = 0; // Para navegadores mais antigos
    }, 0);

    this.searchActive = true;
    this.viewAllPosts = true

  }
  handleToBack() {
    this.searchActive = false;
    this.searchTerm = ''
    this.selectedCategory = ''

  }

  filteredPosts() {
    this.selectedCategory = ''
    if (!this.searchTerm || this.searchTerm.length < 3) {
      return;
    }
    window.scrollTo(0, 0);

    this.filteredPost = this.posts.filter(post => {

      const matchesTerm = this.searchTerm
        ? post.title.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        post.description.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        post.category.some((el: any) => el.toLowerCase().includes(this.searchTerm.toLowerCase()))
        : true; // Se o input estiver vazio, passa todos

      return matchesTerm; // Combina os filtros
    });

    // Atualiza os estados de controle
    this.searchActive = true;
    this.viewAllPosts = false;
    this.showModal = false;

  }
  filteredCategoryPost() {
    this.searchTerm = ''
    if (!this.selectedCategory) {
      this.searchActive = false;
      this.filteredPost = [...this.posts]; // Restaura todos os posts
      return;
    }

    if (this.selectedCategory === 'Todos') {
      this.filteredPost = [...this.posts];
      this.searchActive = true;
      this.viewAllPosts = false;
      this.showModal = false;
      window.scrollTo(0, 0);
      return;
    }
  window.scrollTo(0, 0);
    this.filteredPost = this.posts.filter(post =>
      post.category.some((el: any) => el.toLowerCase().includes(this.selectedCategory.toLowerCase()))
    );

    this.searchActive = true;
    this.viewAllPosts = false;
    this.showModal = false;
  }
  parseDate(dateString: string): number {
    const parts = dateString.split('/').map(Number);
  
    if (parts.length === 3) {
      const [day, month, yearPart] = parts;
      let year = yearPart;
  
      if (yearPart < 100) {
        // Se o ano for dois dígitos, adiciona 2000 (pode ajustar conforme necessidade)
        year += 2000;
      }
  
      return new Date(year, month - 1, day).getTime();
    } else {
      console.warn('Formato de data inválido:', dateString);
      return 0; // Ou lance um erro se preferir
    }
  }



}



